import { makeAutoObservable } from 'mobx'
import { type IResponseTwilioConversation } from 'entities/Call/api/types'

export class TwilioConversation {
  id: number | null
  inbox_id: number | null
  contact_id: number | null
  number_id: number | null

  constructor(payload: IResponseTwilioConversation) {
    this.id = payload.id
    this.inbox_id = payload.inbox_id
    this.contact_id = payload.contact_id
    this.number_id = payload.number_id

    makeAutoObservable(this)
  }

  setId = (id: number) => {
    this.id = id
  }
}
